import { useEffect, useState } from "react";

const ACTIVITY_EVENTS = ["scroll", "mousemove", "keydown", "touchstart"] as const;
const DELAY_AFTER_ACTIVITY_MS = 12000;

// Waits for a first real sign of engagement (scroll/mouse/keyboard/touch)
// before flipping true, then a short delay on top of that — so the auto
// prompt never fires the instant a page mounts, only once someone has
// actually started reading it.
export function useSignsOfLife(enabled: boolean): boolean {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!enabled || ready) return;

    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    const onActivity = () => {
      ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, onActivity));
      timeoutId = setTimeout(() => setReady(true), DELAY_AFTER_ACTIVITY_MS);
    };

    ACTIVITY_EVENTS.forEach((event) =>
      window.addEventListener(event, onActivity, { passive: true, once: true })
    );

    return () => {
      ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, onActivity));
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [enabled, ready]);

  return ready;
}
